export default "__VITE_ASSET__CzIBG35I__"